import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';
import NavBar from './shared/NavBar';
import Footer from './shared/Footer';

const TermsAndConditions = () => {
  return (
    <Box sx={{ bgcolor: '#FAFAFA', minHeight: '100vh' }}>
      <NavBar />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: '16px' }}>
          <Typography variant="h3" gutterBottom sx={{ color: '#FF6B35', fontWeight: 'bold', mb: 3 }}>
            Terms and Conditions
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 3 }}>
            Welcome to YoungPresso! These Terms and Conditions govern your use of our website and services. 
            By accessing or using YoungPresso, you agree to be bound by these terms. Youngpresso is a website under company Trade name: Mettlesome
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            1. Subscription Services
          </Typography>
          <Typography variant="body1" paragraph>
            YoungPresso offers subscription-based news and educational content for children. By subscribing to our services, 
            you agree to the payment terms specified at the time of purchase. Subscription fees are charged on a recurring 
            basis according to the plan you select. Every Month for the Monthly Plan and Every Year for the Annual Plan.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            2. Online Payment
          </Typography>
          <Typography variant="body1" paragraph>
            For financial transactions YoungPresso uses a 3rd party secure payment gateway provided by “Razorpay”. We do not store your Credit/Debit Card information in our database.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            3. Content Usage
          </Typography>
          <Typography variant="body1" paragraph>
            All content provided through YoungPresso is for personal, non-commercial use only. You may not reproduce, 
            distribute, modify, or create derivative works based on our content without explicit permission.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            4. Parental Responsibility
          </Typography>
          <Typography variant="body1" paragraph>
            YoungPresso is designed for children with parental supervision. Parents or guardians are responsible for 
            monitoring children's use of our services and ensuring the content is appropriate for their child's age and 
            development level. In case of complaints, please contact us at <b>support@youngpresso.com</b>.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            5. Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your personal 
            information. By using YoungPresso, you consent to our data practices as described in our Privacy Policy.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            YoungPresso and its affiliates shall not be liable for any indirect, incidental, special, consequential, or 
            punitive damages arising out of or relating to your use of our services.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            7. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately 
            upon posting on our website. Your continued use of YoungPresso after any changes indicates your acceptance of 
            the modified terms.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#06AED5', fontWeight: 'bold', mt: 4 }}>
            8. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms and Conditions are governed by and construed in accordance with the laws of India, without regard 
            to its conflict of law principles.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="body1" paragraph sx={{ fontStyle: 'italic' }}>
            Last updated: April 26, 2025
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms and Conditions, please contact us at support@youngpresso.com.
          </Typography>
        </Paper>
      </Container>
      <Footer />
    </Box>
  );
};

export default TermsAndConditions;
